
import {catchError} from 'rxjs/operators';
import { Injectable, Optional } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import * as _ from 'lodash';
import { Router } from '@angular/router';
import { ES5ZoneAwareRouter } from '../../../app/elements-routing/es5ZoneAwareRouter';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(@Optional() private readonly router: ES5ZoneAwareRouter) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {

        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', err.error.message);
        } else {
          if (err.status === 401) {
            this.router.navigate([{outlets: { eepay: ['error', 401]}}]);
          }

          // Forbidden errors should not happen if we have the right entitlements,
          // therefore, we let the entitlements code handle them since they will redirect.
          if (_.includes([403, 0], err.status)) {
            throw err;
          }
        }

        return next.handle(request);
      }));
  }
}
